import React from 'react';

const DateDivider = ({ date, isSticky = false }) => {
  // Format the date for display
  const formatDate = (dateString) => {
    // Ensure we're parsing the date string as UTC if it doesn't have a timezone indicator
    let messageDateString = dateString;
    if (!dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('T')) {
      // If no timezone indicator and no 'T', assume it needs one
      messageDateString = dateString + 'Z';
    } else if (dateString.includes('T') && !dateString.endsWith('Z') && !dateString.includes('+')) {
      // Has 'T' but no timezone indicator, add 'Z'
      messageDateString = dateString + 'Z';
    }
    
    // Parse the UTC date string and convert to local time
    const messageDate = new Date(messageDateString);
    
    // Get today's date in local timezone
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    
    // Reset time parts for accurate date comparison
    // Use local dates for comparison
    const resetTime = (date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    };
    
    // Get the message date in local timezone for comparison
    // The messageDate is already in local time after new Date() conversion
    const messageDateReset = resetTime(messageDate);
    const todayReset = resetTime(today);
    const yesterdayReset = resetTime(yesterday);
    
    // Check if it's today
    if (messageDateReset.getTime() === todayReset.getTime()) {
      return 'Today';
    }
    
    // Check if it's yesterday
    if (messageDateReset.getTime() === yesterdayReset.getTime()) {
      return 'Yesterday';
    }
    
    // Check if it's within the last week
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    
    if (messageDate > oneWeekAgo) {
      // Return day of week
      return messageDate.toLocaleDateString('en-US', { weekday: 'long' });
    }
    
    // Check if it's this year
    if (messageDate.getFullYear() === today.getFullYear()) {
      // Return month and day
      return messageDate.toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric' 
      });
    }
    
    // Return full date for older messages
    return messageDate.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div 
      className={`flex items-center justify-center px-4 relative animate-fadeIn ${
        isSticky ? 'sticky top-0 z-10 bg-gray-900/95 backdrop-blur-sm py-2 my-0' : 'my-6'
      }`}
      style={{
        animation: 'fadeIn 0.5s ease-out'
      }}
    >
      <div className="absolute inset-0 flex items-center">
        <div className={`w-full h-px bg-gradient-to-r from-transparent ${
          isSticky ? 'via-gray-700/50' : 'via-gray-700/30'
        } to-transparent`}></div>
      </div>
      <div className={`relative px-3 ${isSticky ? 'bg-gray-900/95' : 'bg-gray-900'}`}>
        <span className={`text-[11px] font-medium tracking-wider ${
          isSticky ? 'text-gray-400' : 'text-gray-500'
        }`}>
          {formatDate(date)}
        </span>
      </div>
    </div>
  );
};

export default DateDivider;